// extracted by mini-css-extract-plugin
export var cardSelected = "_ii-2";
export var image = "_ii-1";
export var table = "_ii-0";